import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  constructionLoan,
  lifeInsuranceLoan,
  easySolarLoan,
  unSecuredBusinessLoanImage,
} from "../assets/Images";

const types = [
  {
    id: 1,
    name: "Construction Loan",
    image: constructionLoan,
    content:
      "Build your dream home with our dedicated construction loan plans. Designed for individuals who already own a residential plot, this loan covers the cost of materials, labor, contractor fees, and other construction-related expenses. Funds are disbursed in stages as the construction progresses, ensuring smooth financial planning throughout the project.",
  },
  {
    id: 2,
    name: "Unsecured Business Loan",
    image: unSecuredBusinessLoanImage,
    content:
      "At Subramaniam Financial Services, we offer collateral-free unsecured business loans designed to support your business growth without the need for asset security. Whether you need funds for working capital, inventory, expansion, or operational expenses, our loan solutions are tailored for small and medium enterprises. With minimal documentation, flexible repayment terms, and fast approvals, you can access the capital you need to run and grow your business smoothly.",
  },
  {
    id: 3,
    name: "Easy Solar Loan",
    image: easySolarLoan,
    content:
      "Switch to clean energy effortlessly with our Easy Solar Loans. Get up to 100% financing, low interest rates, and flexible EMIs. Ideal for homes and businesses looking to save on electricity bills.",
  },
  {
    id: 4,
    name: "Life Insurance Loan",
    image: lifeInsuranceLoan,
    content:
      "Secure your family’s future with our trusted Life Insurance plans. Whether it’s term insurance, whole life, or endowment policies, we offer tailored solutions to ensure financial protection, peace of mind, and long-term savings for your loved ones in the event of any uncertainties.",
  },
];

const LoanTypes = () => {
  const [activeLoan, setActiveLoan] = useState(types[0]);

  return (
    <div className="bg-white rounded-2xl shadow-xl px-6 py-10 max-w-6xl mx-auto w-full mt-8 mb-4">

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 pb-8">
        {types.map((loan) => (
          <button
            key={loan.id}
            onClick={() => setActiveLoan(loan)}
            className={`w-full px-6 py-4 rounded-xl border text-base sm:text-lg font-semibold transition-colors duration-300 ${
              activeLoan.id === loan.id
                ? "border-blue-600 text-blue-600 bg-blue-50 shadow"
                : "border-gray-300 text-gray-800 hover:border-blue-400 hover:text-blue-600"
            }`}
          >
            {loan.name}
          </button>
        ))}
      </div>


      {/* Animated content area */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16 items-center min-h-[300px]">
        <AnimatePresence mode="wait">
          <motion.div
            key={activeLoan.id + "-img"}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 20 }}
            transition={{ duration: 0.4 }}
            className="w-full flex justify-center md:justify-start"
          >
            <img
              src={activeLoan.image}
              alt={activeLoan.name}
              className="w-full rounded-lg object-cover"
            />
          </motion.div>
        </AnimatePresence>

        <AnimatePresence mode="wait">
          <motion.div
            key={activeLoan.id + "-text"}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.4 }}
            className="w-full"
          >
            <p className="text-gray-800 text-lg leading-relaxed font-medium">
              {activeLoan.content}
            </p>
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
};

export default LoanTypes;
